import { render, staticRenderFns } from "./drawerView.vue?vue&type=template&id=4ff12f5c&scoped=true&"
import script from "./drawerView.vue?vue&type=script&lang=js&"
export * from "./drawerView.vue?vue&type=script&lang=js&"
import style0 from "./drawerView.vue?vue&type=style&index=0&id=4ff12f5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff12f5c",
  null
  
)

export default component.exports